import React, { useEffect, useState } from "react";
import Header from "./Header";
import HeaderMobile from "./newHeaderMobil";
import HeaderPage from "./../components/common/HeaderPage";
import { Container, makeStyles } from "@material-ui/core";
import Oms from "./oms";
import ChangeOms from "./changeOms/index";
// import UpdateSejam from './updateSejam';
import UpdateSejam from "./sejam/index";
import NewFooter from "./newFooter";
import { useDispatch, useSelector } from "react-redux";
import RedirectRegisterUser from "./registrationRedirectModal/registrationRedirectModal";
import { actionTypes as actionOms } from "./../redux/oms/customer_select_get_kyc_profile";
import ModalNotif from "./../components/common/modalNotif/modalNotif";
import ChatGapify from "./chatGapify/chatGapify";

let useStyles = makeStyles((theme) => ({
  header: {
    position: "-webkit-sticky" /* Safari */,
    position: "sticky",
    top: 0,
    zIndex: 999,
  },
  header_Lg: {
    display: "block",
    "@media(max-width:1100px)": {
      display: "none",
    },
  },
  header_sm: {
    display: "none",
    "@media(max-width:1100px)": {
      display: "block",
    },
  },
}));

export default function Layout({ children, home, disableHeader }) {
  let classes = useStyles();
  let dispatch = useDispatch();
  let lengthScroll = 75;
  const [flagHeader, setflagHeader] = useState(false);
  const [flagOms, setflagOms] = useState(false);
  const [flagSejam, setflagSejam] = useState(false);
  const [falgRegister, setFlagRegister] = useState(false);
  const [flagNotif, setFlagNotif] = useState({
    service: null,
    flag: false,
    message: "",
  });

  const reducerProfile = useSelector(
    (state) => state.reducer_customer_get_kyc_profile,
  );

  useEffect(() => {
    const header = document.querySelector("#back-to-top-anchor-header");
    const toggleClass = "is-sticky";

    window.addEventListener("scroll", () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > lengthScroll) {
        header.classList.add(toggleClass);
        setflagHeader(true);
      } else {
        header.classList.remove(toggleClass);
        setflagHeader(false);
      }
    });
  }, []);

  useEffect(() => {
    if (reducerProfile?.flag) {
      setflagOms(true);
    }
  }, [reducerProfile?.flag]);

  useEffect(() => {
    if (!flagOms) {
      dispatch({
        type: actionOms.clubmemberCustomerKycOmsFlag,
        payload: false,
      });
    }
  }, [flagOms]);

  let dataMenu = [
    {
      label: "سرمایه‌گذاری",
      route: "/",
      child: [
        {
          label: "از کجا شروع کنیم",
          route: "/",
          child: [
            {
              label: "شروع سرمایه‌گذاری",
              route: "/Investment",
            },
            {
              label: "سوالات متداول",
              route: "/faq",
            },
            {
              label: "اخبار و آموزش بورس ",
              route: "/news",
            },
            // {
            //     label: "آموزش",
            //     route: "/education",
            // },
          ],
        },
        {
          label: "سامانه‌های معاملاتی",
          route: "/",
          child: [
            {
              label: "سامانه آنلاین",
              route: "/Trades",
            },
            {
              label: "تغییر پنل معاملاتی",
              route: "/",
              action: (data) => setflagOms(true),
            },
          ],
        },
      ],
    },
    {
      label: "بازارها",
      route: "/",
      child: [
        {
          label: "اوراق بهادار",
          route: "/",
          child: [
            {
              label: "درباره اوراق بهادار",
              route: "/oragh",
            },
            {
              label: "درباره کد بورسی و سجام",
              route: "https://reg.pouyanbroker.ir/auth/phone",
            },
            {
              label: "فایل‌های آموزشی",
              route: "/education",
            },
          ],
        },
        {
          label: "بورس کالا",
          route: "/",
          child: [
            {
              label: "درباره بورس کالا",
              route: "/kala",
            },
            {
              label: "گواهی سپرده مشتقه کالایی",
              route: "/Content/GetContentHtml/gavahikala",
            },
            {
              label: "خرید خودرو در بورس",
              route: "/khodro",
            },
            // {
            //     label: "اطلاعیه های عرضه",
            //     route: "/bourseKala",
            // },
            // {
            //     label: "درباره بورس کالا",
            //     route: "/kala",
            // },
            // {
            //     label: "معاملات مشتقه کالا (آتی)",
            //     route: "https://pouyan.ebgo.ir/Login",
            // },
            // {
            //     label: "اخبار و تحلیل‌ها",
            //     route: "/",
            // },
            // {
            //     label: "ثبت نام خرید خودرو",
            //     route: "/khodro",
            // },
            // {
            //     label: "اطلاعیه های عرضه،آمار معاملات",
            //     route: "/bourseKala",
            // },
          ],
        },
        {
          label: "بورس انرژی",
          route: "/",
          child: [
            {
              label: "درباره بورس انرژی",
              route: "/energy",
            },
          ],
        },
      ],
    },
    {
      label: "تامین مالی جمعی",
      route: "https://pouyancrowd.ir",
      child: [],
    },
    {
      label: "شعب و دفاتر",
      route: "/Shoab",
      child: [],
    },
    {
      label: "مای پویان",
      route: "/",
      child: [
        {
          label: "مای پویان چیست؟",
          route: "/Content/GetContentHtml/WhatIsMyPouyan",
        },
        {
          label: "ورود به مای پویان",
          route: "https://my.pouyanbroker.ir",
        },
      ],
    },
    {
      label: "درباره پویان",
      route: "/",
      child: [
        {
          label: "آشنایی با پویان",
          route: "/AboutUs",
          child: [
            {
              label: "مدیران",
              route: "/MangementUsers",
            },
            {
              label: "شعب و دفاتر",
              route: "/Shoab",
            },
            {
              label: "شماره حسا‌ب‌ها",
              route: "/AcountNumber",
            },
            {
              label: "درباره پویان",
              route: "/AboutUs",
            },
            {
              label: " ارتباط با ما",
              route: "/ContactUs",
            },
          ],
        },
      ],
    },
    // {
    //     label: "همکاران ما",
    //     route: "/",
    //     child: [
    //         {
    //             label: "همکاران ما",
    //             route: "/",
    //             child: [
    //                 {
    //                     label: "چارتیکس",
    //                     route: "/chartix",
    //                 },
    //             ],
    //         },
    //     ]
    // },
  ];

  const handelNotif = (services) => {
    switch (services) {
      case "sejam":
        setflagSejam(true);
        return;
      case "changeOms":
        setflagOms(true);
        return;

      default:
        break;
    }
  };

  return (
    <Container maxWidth={false} style={{ padding: 0 }}>
      <div
        className={classes["header"]}
        id="back-to-top-anchor-header"
        style={{ backgroundColor: home ? "#071b2c" : "transpaernt" }}
      >
        <div className={classes["header_Lg"]}>
          <Header
            home={home}
            data={dataMenu}
            flagHeader={flagHeader}
            setflagOms={setflagOms}
            setflagSejam={setflagSejam}
          />
        </div>

        <div className={classes["header_sm"]}>
          <HeaderMobile
            home={home}
            data={dataMenu}
            flagHeader={flagHeader}
            setflagOms={setflagOms}
            setflagSejam={setflagSejam}
          />
        </div>
      </div>
      {!home && !disableHeader && <HeaderPage />}
      <div>{children}</div>
      <div>
        <NewFooter />
      </div>
      {flagOms && (
        <ChangeOms
          open={flagOms}
          setOpen={setflagOms}
          setFlagRegister={setFlagRegister}
          setFlagNotif={setFlagNotif}
        />
      )}
      {flagSejam && (
        <UpdateSejam
          open={flagSejam}
          setOpen={setflagSejam}
          setFlagRegister={setFlagRegister}
          setFlagNotif={setFlagNotif}
        />
      )}
      {falgRegister && (
        <RedirectRegisterUser open={falgRegister} setOpen={setFlagRegister} />
      )}
      {flagNotif?.flag && (
        <ModalNotif
          open={flagNotif}
          setOpen={setFlagNotif}
          handelClick={() => handelNotif(flagNotif?.service)}
        />
      )}
      <ChatGapify />
    </Container>
  );
}

// export let dataMenutest = [
//     {
//         label: "سرمایه‌گذاری",
//         route: "/",
//         child: [
//             {
//                 label: "از کجا شروع کنیم",
//                 route: "/",
//                 child: [
//                     {
//                         label: "شروع سرمایه‌گذاری",
//                         route: "/Investment",
//                     },
//                     {
//                         label: "سوالات متداول",
//                         route: "/faq",
//                     },
//                     {
//                         label: "اخبار و آموزش بورس ",
//                         route: "https://mag.pouyanbroker.ir/",
//                         badge: {
//                             title: 'مجله پویان'
//                         }
//                     },
//                     // {
//                     //     label: "آموزش",
//                     //     route: "/education",
//                     // },
//                 ],
//             },
//             {
//                 label: "سامانه‌های معاملاتی",
//                 route: "/",
//                 child: [
//                     {
//                         label: "سامانه آنلاین",
//                         route: "/Trades",
//                     },
//                     {
//                         label: "تغییر پنل معاملاتی",
//                         route: "/",
//                         // action: (data) => setflagOms(true)
//                     },
//                     {
//                         label: "مای پویان | My pouyan",
//                         route: "https://my.pouyanbroker.ir",
//                     },
//                 ],
//             },
//         ]
//     },
//     {
//         label: "معاملات آنلاین",
//         route: "/",
//         child: [
//             {
//                 label: "اوراق بهادار",
//                 route: "/",
//                 child: [
//                     {
//                         label: "درباره اوراق بهادار",
//                         route: "/oragh",
//                     },
//                     {
//                         label: "درباره کد بورسی و سجام",
//                         route: "https://reg.pouyanbroker.ir/auth/phone",
//                     },
//                     {
//                         label: "فایل‌های آموزشی",
//                         route: "/education",
//                     },
//                 ],
//             },
//             {
//                 label: "بورس کالا",
//                 route: "/",
//                 child: [
//                     {
//                         label: "درباره بورس کالا",
//                         route: "/kala",
//                     },
//                     {
//                         label: "معاملات آتی کالا",
//                         route: "https://pouyan.ebgo.ir/Login",
//                     },
//                     {
//                         label: "خرید خودرو در بورس",
//                         route: "/khodro",
//                     },
//                     // {
//                     //     label: "اطلاعیه های عرضه",
//                     //     route: "/bourseKala",
//                     // },
//                     // {
//                     //     label: "درباره بورس کالا",
//                     //     route: "/kala",
//                     // },
//                     // {
//                     //     label: "معاملات مشتقه کالا (آتی)",
//                     //     route: "https://pouyan.ebgo.ir/Login",
//                     // },
//                     // {
//                     //     label: "اخبار و تحلیل‌ها",
//                     //     route: "/",
//                     // },
//                     // {
//                     //     label: "ثبت نام خرید خودرو",
//                     //     route: "/khodro",
//                     // },
//                     // {
//                     //     label: "اطلاعیه های عرضه،آمار معاملات",
//                     //     route: "/bourseKala",
//                     // },
//                 ],
//             },
//             {
//                 label: "بورس انرژی",
//                 route: "/",
//                 child: [
//                     {
//                         label: "درباره بورس انرژی",
//                         route: "/energy",
//                     },
//                     // {
//                     //     label: "اخبار و تحلیل‌ها",
//                     //     route: "/",
//                     // },
//                 ],
//             },
//         ]
//     },
//     {
//         label: "شعب و دفاتر",
//         route: "/Shoab",
//         child: []
//     },
//     {
//         label: "درباره پویان",
//         route: "/",
//         child: [
//             {
//                 label: "آشنایی با پویان",
//                 route: "/AboutUs",
//                 child: [
//                     {
//                         label: "مدیران",
//                         route: "/MangementUsers",
//                     },
//                     {
//                         label: "شعب و دفاتر",
//                         route: "/Shoab",
//                     },
//                     {
//                         label: "شماره حسا‌ب‌ها",
//                         route: "/AcountNumber",
//                     },
//                     {
//                         label: "درباره پویان",
//                         route: "/AboutUs",
//                     },
//                     {
//                         label: " ارتباط با ما",
//                         route: "/ContactUs",
//                     },
//                 ],
//             },
//         ]
//     },
//     // {
//     //     label: "مجله پویان",
//     //     route: "https://mag.pouyanbroker.ir/",
//     //     child: []
//     // },

//     {
//         label: "همکاران ما",
//         route: "/",
//         child: [
//             {
//                 label: "همکاران ما",
//                 route: "/",
//                 child: [
//                     {
//                         label: "چارتیکس",
//                         route: "https://chartix.ir",
//                     },
//                 ],
//             },
//         ]
//     },

// ]
